<template>
<div>
    <base-header v-once pageName="문자 보내기" :popup="true"></base-header>
    
    <section id="wrap">
        <div class="smsWrap">
            <p>총 <em>{{selectedCount}}</em>명이 선택되었습니다.</p>
            <base-selectbox selectName="문자 유형"
                :default="''" 
                ref="subject"
                v-on:selectSearch="typeSelect"
                :options="smsTempleteList" 
                :only="false"
            ></base-selectbox>
        </div>
        <div class="sms-input">
            <textarea ref="msg" v-model.trim="msg" id="msg" v-on:input="check_length"></textarea>
            <span><em>{{msgLength}}</em>/45</span>
        </div>
    </section>  
    <div class="btnWrap">
        <button type="button" class="white" @click="close()">취소</button>
        <button type="button" class="red" @click="sendSms()">전송</button>
    </div>  
</div>
</template>

<script>
export default {
  data() {
      return{
          selectedCount: 0,
          smsUserList: [
              {
                encCustNm: "",
                encCustTel: ""
              }
          ],
          smsTempleteList: [{text:'직접입력',value:''}],
          msg: "",
          msgLength: 0
      };
  },
  methods: {
    typeSelect: function(data){
        //console.log(data);
        this.msg = data;
    },
    close: function(){
        window.app.$root.$utils.nativeIf.outbound.close(false);
    },
    check_length: function(e){
      // var id = e.target.id;
      // var val =  e.target.value;         
      // if("msg" == id){    
      //   this.$utils.stringUtil.checkOverLength(val, 10, '메세지')
      // }
      
      //console.log("SmsSend.vue check_length :",e.target.value.length);
      this.msgLength = e.target.value.length;
      if(e.target.value.length > 45){
        this.msg = e.target.value.substr(0,45);
      }
    },
    validate() { // 유효성 체크
        // console.log("SmsSend.vue validate this.subject:",this.$refs.subject.selected);
        // console.log("SmsSend.vue validate this.msg:",this.msg);
        // console.log("SmsSend.vue validate this.smsUserList:",this.smsUserList);
            
        if (this.$utils.stringUtil.isNull(this.msg)) {
            alert("메세지를 입력해주세요.");
            return false;
        }      
      return true;
    },
    sendSms: function(){
      var that = this;
      var validate = this.validate();
      if(!validate) {
        return;
      }
      if(!confirm("문자를 발송하시겠습니까?")){
        return;
      }
      var smsUserListJsonString = JSON.stringify(this.smsUserList);

      var subject = this.$refs.subject.selected;
      if(subject == '직접입력' || subject == '문자 유형을 선택해주세요.'){
        subject = this.msg.substr(0,8);
        subject = subject.replace(/(\s*)/g, "");
      }
      
      var params = {
            subject: subject,
            msg: this.msg,
            smsUserListJsonString: smsUserListJsonString
        }

      //console.log("SmsSend.vue api.myCstmr.sendSms params:",params);

      this.$api.myCstmr.sendSms(params)
        .then(function() {
            var child = {
              name: 'sms-send-complete',
              data: {res:'ok'}
            };
            that.$utils.nativeIf.outbound.sendChildData(child);
        })
        .catch(function(error) {
            alert(error.rtMsg);
        });
    }
  },
  mounted: function() { //  인스턴스가 마운트 된 직후
    var parent = this.$store.getters.parent;
        if(parent.name == 'sms-user-list'){  // 부모창에서 받은 고객목록.
            //console.log("SmsSend.vue mounted this.$store.getters.parent.data.smsUserList", parent.data.smsUserList);
            this.smsUserList = parent.data.smsUserList;
            this.selectedCount = this.smsUserList.length;
            
            // 넘어온 파라메터 초기화
            parent = {
                name: 'sms-user-list',
                data: {smsUserList:""}
            };
            this.$store.commit("SET_UI_PARENT", parent);
           // console.log(this.smsUserList)
        }
    
      var that = this;

      this.$api.myCstmr.getSmsTempleteList()
        .then(function(res) {
            //console.log("SmsSend.vue api.myCstmr.getSmsTempleteList res:",res);
            
            var templete = {};
            res.forEach(element => {
                templete = {text:element.cdNm, value:element.cdVl1};
                that.smsTempleteList.push(templete);
            });
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
  }
};
</script>
